import React, { useState } from "react";
import { FormatCurrency } from "../../../utils/FormatCurrency";
import { useShoppingCart } from "../../../context/CartContext.tsx/ShoppingCartContext";

interface freeVariantProps {
  item_image: string;
  title: string;
  subtitle: string;
  price: string | any;
  variant_title: string;
  is_free_xmember: number | any;
  temp_cart_id?: number | any;
  cart_id: number | any;
  variant_id: number | any;
  product_type?: string;
  power_type?: number | any;
  product_title?: string;
}

const FreeVariant = ({
  item_image,
  title,
  subtitle,
  price,
  variant_title,
  is_free_xmember,
  temp_cart_id,
  cart_id,
  variant_id,
  product_type,
  power_type,
  product_title,
}: freeVariantProps) => {
  const { removeCartItem } = useShoppingCart();
  const [isDialogOpen, setIsDialogOpen] = useState(false);


  const removeItemPayload = {
    cart_id: cart_id,
    cart_item_id: temp_cart_id,
  };

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
    // console.log(isDialogOpen);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleConfirm = () => {
    removeCartItem(removeItemPayload);
    setIsDialogOpen(false);
  };

  return (
    <div className="freeVariant">
      {/* <a href="#"> */}
      <div className="productInfo">
        <div className="productInfoLeft">
          <div className="productImage">
            <img src={item_image} alt="" />
          </div>
          <div className="productTitle_wrapper">
            <h3 className="productTitle">{title}</h3>
            <div className="productSubTitle_variant">
              <span className="productSubTitle">{subtitle} </span>
              {variant_title !== "Default Title" ? (
                <span>{variant_title}</span>
              ) : (
                <span></span>
              )}
            </div>
          </div>
        </div>
        <div className="freeTag">
          {is_free_xmember === 1 && (
            <div className="productPriceWrapper"  onClick={() => handleOpenDialog()}>
              <button 
                type="button" 
                className="productPrice"  
               
                >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M14 3.98568C11.78 3.76568 9.54667 3.65234 7.32 3.65234C6 3.65234 4.68 3.71901 3.36 3.85234L2 3.98568"
                    stroke="#666666"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M5.6665 3.31203L5.81317 2.4387C5.91984 1.80536 5.99984 1.33203 7.1265 1.33203H8.87317C9.99984 1.33203 10.0865 1.83203 10.1865 2.44536L10.3332 3.31203"
                    stroke="#666666"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12.5664 6.09375L12.1331 12.8071C12.0598 13.8537 11.9998 14.6671 10.1398 14.6671H5.85977C3.99977 14.6671 3.93977 13.8537 3.86644 12.8071L3.43311 6.09375"
                    stroke="#666666"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6.88672 11H9.10672"
                    stroke="#666666"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6.3335 8.33203H9.66683"
                    stroke="#666666"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          )}

          <div className="priceTag">
            <p className="freeTagPrice">{FormatCurrency(price)}</p>
            <p className="freeTagText">FREE!</p>
          </div>
          {/* <div className='priceTag'>
                            <p className='freeTagPrice'>{FormatCurrency(props.price)}</p>
                            <p className='freeTagText'>FREE!</p>
                        </div> */}
        </div>
      </div>
      <svg
        className="offerLogo"
        width="96"
        height="74"
        viewBox="0 0 96 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M99.3646 61.118L94.3554 51.0449C93.4985 49.3218 93.3062 46.4417 93.9059 44.6557L97.5039 33.9392C98.9698 29.5733 96.597 24.8018 92.2311 23.3359L81.5643 19.7545C79.7782 19.1548 77.5977 17.2634 76.7409 15.5404L71.7317 5.46719C69.6884 1.35841 64.6279 -0.340682 60.5191 1.70255L50.3467 6.67845C48.6733 7.55195 45.7932 7.74428 43.9575 7.12794L33.2907 3.54653C28.9248 2.08065 24.1533 4.45344 22.6874 8.81939L19.106 19.4862C18.5063 21.2723 16.6149 23.4527 14.8918 24.3096L4.81868 29.3188C0.709894 31.362 -0.989194 36.4226 1.05404 40.5313L6.06325 50.6045C6.92009 52.3275 7.11242 55.2076 6.51275 56.9937L2.93134 67.6605C1.46546 72.0265 3.83824 76.798 8.20419 78.2638L18.871 81.8453C20.6571 82.4449 22.8375 84.3363 23.6944 86.0594L28.7036 96.1326C30.7468 100.241 35.8074 101.94 39.9161 99.8972L49.9893 94.888C51.7123 94.0311 54.5924 93.8388 56.3785 94.4385L67.0453 98.0199C71.4113 99.4858 76.1828 97.113 77.6487 92.747L81.2301 82.0802C81.8297 80.2942 83.7211 78.1137 85.4442 77.2569L95.5174 72.2476C99.7583 70.304 101.457 65.2435 99.3646 61.118ZM35.3531 29.3025C36.2692 26.5737 39.2514 25.0908 41.9801 26.0069C44.7089 26.9231 46.1918 29.9053 45.2757 32.634C44.3595 35.3627 41.4269 36.8624 38.6486 35.9296C35.9199 35.0134 34.4369 32.0312 35.3531 29.3025ZM32.0664 64.2484C31.0723 64.7428 30.0131 64.7736 29.0704 64.4571C28.1278 64.1406 27.3017 63.4768 26.8074 62.4827C25.8517 60.5609 26.6512 58.1795 28.5731 57.2237L68.3356 37.4505C70.2574 36.4948 72.6389 37.2944 73.5946 39.2162C74.5503 41.1381 73.7507 43.5195 71.8288 44.4752L32.0664 64.2484ZM58.4218 75.692C55.6435 74.7592 54.1605 71.777 55.0767 69.0483C55.9928 66.3196 58.975 64.8366 61.7037 65.7528C64.4325 66.6689 65.9154 69.6511 64.9993 72.3798C64.0831 75.1086 61.1505 76.6082 58.4218 75.692Z"
          fill="#469DA1"
          fillOpacity="0.3"
        />
      </svg>

      {/* </a> */}

      {/* <LineItemRemoveProduct /> */}

      {isDialogOpen && (
        <div className="dialogBackdrop">
          <div className="dialog">
            <div className="dialogTextWrapper">
              {/* <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 16 16" fill="none"><path d="M14 3.98568C11.78 3.76568 9.54667 3.65234 7.32 3.65234C6 3.65234 4.68 3.71901 3.36 3.85234L2 3.98568" stroke="#666666" strokeLinecap="round" strokeLinejoin="round"></path><path d="M5.6665 3.31203L5.81317 2.4387C5.91984 1.80536 5.99984 1.33203 7.1265 1.33203H8.87317C9.99984 1.33203 10.0865 1.83203 10.1865 2.44536L10.3332 3.31203" stroke="#666666" strokeLinecap="round" strokeLinejoin="round"></path><path d="M12.5664 6.09375L12.1331 12.8071C12.0598 13.8537 11.9998 14.6671 10.1398 14.6671H5.85977C3.99977 14.6671 3.93977 13.8537 3.86644 12.8071L3.43311 6.09375" stroke="#666666" strokeLinecap="round" strokeLinejoin="round"></path><path d="M6.88672 11H9.10672" stroke="#666666" strokeLinecap="round" strokeLinejoin="round"></path><path d="M6.3335 8.33203H9.66683" stroke="#666666" strokeLinecap="round" strokeLinejoin="round"></path></svg> */}
              <div className="productImage">
                <img width="64px" src={item_image} alt="" />
              </div>
              <h2>Remove item from cart?</h2>
              <p>Are you sure you want to remove this item?</p>
            </div>
            <div className="buttonContainer">
              <button className="confirmButton" onClick={() => handleConfirm()}>
                Yes, Remove
              </button>
              <button className="cancelButton" onClick={handleCloseDialog}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FreeVariant;
